import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Modal } from "react-bootstrap";

import { apiData } from "../../../actions";
import { _Deals_ } from "../../../Redux/Action/Action";
import DataLoader from "../../../Utils/DataLoader";
import SpcificPageModal from "../../Modals/SpcificPageModal";

import "swiper/css";
import "swiper/css/navigation";

export default function AllInclusiveSlug() {
  const dispatch = useDispatch();
  const place = useSelector((state) => state.place);

  const [dealsData, setDealsData] = useState([]);
  const [singleData, setSingleData] = useState("");
  const [inclusiveScript, setInclusiveScript] = useState("");

  const [dealsModalOpen, setDealsModalOpen] = useState(false);
  const [scriptModalOpen, setScriptModalOpen] = useState(false);
  const [dealsModalLoader, setDealsModalLoader] = useState(false);
  const [scriptModalLoader, setScriptModalLoader] = useState(false);
  const [commonLoader, setCommonLoader] = useState(false);
  const [specificModal, setSpecificModal] = useState(false);

  /* ================= API CALLS ================= */

  const GetInclusiveDeals = async () => {
    setCommonLoader(true);
    try {
      const res = await apiData.inclusiveDeals({ city: place, limit: 20 });
      if (res?.status >= 200 && res.status < 400) {
        setDealsData(res?.data?.data?.tourSlider || []);
      }
    } catch (err) {
      console.error("Inclusive deals error", err);
      setDealsData([]);
    } finally {
      setCommonLoader(false);
    }
  };

  const GetTourTravel = async () => {
    setCommonLoader(true);
    try {
      const res = await apiData.toursTravelAll({ city: place });
      if (res?.status >= 200 && res.status < 400) {
        const data = res?.data?.data;
        setSingleData(typeof data === "string" ? data : "");
      } else {
        setSingleData("");
      }
    } catch (err) {
      console.error("Tour travel error", err);
      setSingleData("");
    } finally {
      setCommonLoader(false);
    }
  };

  const GetInclusiveDealsScript = async () => {
    try {
      const res = await apiData.inclusiveDeals({ city: place });
      if (res?.status >= 200 && res.status < 400) {
        const guideArr = res?.data?.data?.getYourGuide;

        if (Array.isArray(guideArr) && guideArr[0]?.content) {
          setInclusiveScript(guideArr[0].content.split('"')[1]);
        } else {
          setInclusiveScript("");
        }
      }
    } catch (err) {
      console.error("Inclusive script error", err);
      setInclusiveScript("");
    }
  };

  /* ================= SCRIPT LOADER ================= */

  const loadEmbedScript = (src, containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    // SAME AS OLD: always fresh container
    container.innerHTML = "";

    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    script.onerror = () => {
      container.innerHTML =
        `<div class="text-center text-danger fw-bold p-4">Data Not Found</div>`;
    };

    container.appendChild(script);
  };

  /* ================= ACTIONS ================= */

  const handleViewAllDeals = () => {
    setDealsModalLoader(true);
    setDealsModalOpen(true);
    setTimeout(() => setDealsModalLoader(false), 400);
  };

  const handleSeeAllScript = () => {
    // only open modal – script will load from effect
    setScriptModalLoader(true);
    setScriptModalOpen(true);
  };

  /* ================= EFFECTS ================= */

  // Main page embed
  useEffect(() => {
    if (singleData && singleData.includes('"')) {
      const src = singleData.split('"')[1];
      loadEmbedScript(src, "singleData");
    }
  }, [singleData]);

  // Inject script WHEN modal is really open (OLD PATTERN RESTORED)
  useEffect(() => {
    if (scriptModalOpen) {
      setTimeout(() => {
        if (inclusiveScript) {
          loadEmbedScript(inclusiveScript, "InclusiveScript");
        } else {
          const c = document.getElementById("InclusiveScript");
          if (c) {
            c.innerHTML =
              `<div class="text-center text-danger fw-bold p-4">Data Not Found</div>`;
          }
        }

        setScriptModalLoader(false);
      }, 1000);     // SAME 1 SEC DELAY AS OLD CODE
    }
  }, [scriptModalOpen, inclusiveScript]);

  // Fetch APIs on place change
  useEffect(() => {
    if (!place) return;

    dispatch(_Deals_());
    GetInclusiveDeals();
    GetTourTravel();
    GetInclusiveDealsScript();
  }, [place, dispatch]);

  // Specific popup first visit
  useEffect(() => {
    const seen = localStorage.getItem("hasSeenSpecficPopup");
    if (!seen && place) {
      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }
  }, [place]);

  /* ================= UI ================= */

  return (
    <>
      {commonLoader ? <DataLoader /> : (<div className="d-flex gap-3 flex-column">
        <div>
          {dealsData.length > 0 ? (
            <>
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                loop
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                navigation
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
                className="all_inclusive_slug_swiper"
              >
                {dealsData.map((ele, index) => (
                  <SwiperSlide key={index}>
                    <div className="resorts-box p-3 bg-white allwebsiteimgwidhig">
                      <img
                        src={ele?.image_link}
                        alt={ele?.title}
                        className="img-fluid"
                      />
                      <h3>{ele?.title?.length > 25
                        ? ele.title.slice(0, 35) + "..."
                        : ele.title}</h3>
                      <p>{ele?.description}</p>
                      <div className="d-flex justify-content-between align-items-center">

                        <div className="price-label">
                          <span>${ele?.price.split(" ")[0]}</span>
                        </div>

                        <div className="book-trip-btn"><a className="flex flex-row" href={ele?.link} target="_blank" rel="noreferrer">Book Trip <i
                          className="fa-solid fa-arrow-right"></i></a></div>
                      </div>

                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="d-flex justify-content-end">
                <button className="view-all-btn" onClick={handleViewAllDeals}>
                  View All <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </>
          ) : (
            <p className="no_data_text">Oops! No Data Available</p>
          )}
        </div>

        <div id="singleData"></div>

        <div className="view-tag d-flex justify-content-center">
          {scriptModalLoader ? (
            <DataLoader />
          ) : (
            <button
              type="button"
              onClick={handleSeeAllScript}
              className="m-4 view-all-btn"
            >
              See All <i className="fa-solid fa-arrow-right"></i>
            </button>
          )}
        </div>
      </div>)}


      {/* Deals Modal */}
      <Modal
        show={dealsModalOpen}
        onHide={() => setDealsModalOpen(false)}
        size="xl"
        className="modal_xl see-pop"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          {dealsModalLoader ? (
            <DataLoader />
          ) : (
            <div className="row gap-2">

              {dealsData.map((ele, idx) => (

                <div className="modalheaderdeals resorts-box col-4 d-flex flex-column p-3 bg-white" key={idx}>
                  <figure>
                    <img
                      src={ele?.image_link}
                      alt={ele?.title}
                      className="img-fluid"
                    />
                  </figure>
                  <h3>{ele?.title?.length > 25
                    ? ele.title.slice(0, 35) + "..."
                    : ele.title}</h3>
                  <div className="d-flex justify-content-between align-items-center">

                    <div className="price-label">
                      <span>${ele?.price.split(" ")[0]}</span>
                    </div>

                    <div className="book-trip-btn"><a className="flex flex-row" href={ele?.link} target="_blank" rel="noreferrer">Book Trip <i
                      className="fa-solid fa-arrow-right"></i></a></div>
                  </div>

                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* SCRIPT MODAL — IMPORTANT ID SAME AS OLD */}
      <Modal
        show={scriptModalOpen}
        onHide={() => setScriptModalOpen(false)}
        size="xl"
        className="modal_xl see-pop"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div id="InclusiveScript"></div>
          {scriptModalLoader && (
            <div className="text-center py-5">
              <div className="spinner-border"></div>
              <p>Loading content...</p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {specificModal && (
        <SpcificPageModal
          specificModal={specificModal}
          setSpecificModal={setSpecificModal}
        />
      )}
    </>
  );
}
